import {
    Component,
    OnInit
} from '@angular/core';
import { CreateUserProto } from '../authentication.constants';
import { Url } from '../../../http/url-constants';
import { WebService } from '../../../http/web-service.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { UserService } from '../../../shared/services/user.service';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {

    public editProfile = new CreateUserProto();
    public dateOfBirth: Date;
    public currentYear = new Date().getFullYear();
    public startYear = new Date().getFullYear() - 200;

    constructor(private webService: WebService, private toaster: ToasterService,
                private userService: UserService) {
    }

    ngOnInit(): void {
        const userData = this.userService.getUserData();
        this.editProfile.userId = userData.userId;
        this.editProfile.firstName = userData.firstName;
        this.editProfile.lastName = userData.lastName;
        this.editProfile.gender = userData.gender;
        this.editProfile.emailId = userData.emailId;
        this.editProfile.password = userData.password;
        this.editProfile.mobileNo = userData.mobileNo;
        this.getUserDetails();
    }

    getUserDetails() {
        this.webService.get(Url.API.authentication.getUserDetails + this.editProfile.userId).subscribe((response) => {
        });
    }

    updateProfile() {
        this.webService.post(Url.API.authentication.editProfile, this.editProfile).subscribe((response) => {
            if (response) {
                this.toaster.show('Successfully Registered!');
            }
        });
    }

}
